<template>
  <v-container class="pa-0 ma-0">
    <v-card outlined class="pa-4 ma-0 d-flex flex-column gap-5" style="height: 350px">
      <!-- Header -->
      <v-container class="chart-header d-flex flex-column pa-0 ma-0">
        <v-card-text class="pa-0 ma-0 text-body-2">
          {{ $t("salesByCustomer") }}
        </v-card-text>
      </v-container>

      <!-- List -->
      <v-container v-if="hasData" class="pa-0 ma-0 scroll-y">
        <v-list class="pa-0 ma-0" dense>
          <v-list-item
            v-for="(item, index) in customers"
            :key="index"
            class="align-start pa-0 ma-0"
          >
            <v-container class="chart-header d-flex justify-space-between pa-0 ma-0">
              <v-list-item-content class="pa-0 ma-0 pt-4">
                <!-- Name + Avatar -->
                <v-container class="pa-0 ma-0 d-flex align-center justify-space-between">
                  <!-- right side (Name + Avatar) -->
                  <v-container class="pa-0 ma-0 d-flex align-center">
                    <v-sheet class="ma-0 pa-0 ml-2" style="border-radius: 12px">
                      <img
                        v-if="item.avatar"
                        :src="item.avatar"
                        height="44"
                        width="44"
                        style="border-radius: 12px"
                      />
                      <v-container
                        style="background-color: #d9d9d9; border-radius: 12px"
                        class="pa-0 py-3 px-3 ma-0"
                        v-else
                      >
                        <v-icon color="grey">mdi-account</v-icon>
                      </v-container>
                    </v-sheet>
                    <v-container class="pa-0 ma-0 d-flex flex-column">
                      <v-card-text class="pa-0 ma-0 text-body-1">
                        {{ item.customer_name }}
                      </v-card-text>
                      <v-card-text class="pa-0 ma-0 text-body-2 grey--text">
                        {{ item.customer_id }}#
                      </v-card-text>
                    </v-container>
                  </v-container>
                  <!-- left side amount and currency  -->
                  <v-container style="width: auto" class="pa-0 ma-0 d-flex">
                    <v-card-text class="pa-0 ma-0 text-body-2">
                      {{ formatPrice(item.amount) }}</v-card-text
                    >
                    <v-card-text class="pa-0 ma-0 text--gray text-body-2">{{
                      $store.state.currency.name
                    }}</v-card-text>
                  </v-container>
                </v-container>

                <!-- Progress -->
                <v-progress-linear
                  :value="getPercent(item.amount)"
                  height="4"
                  rounded
                  color="primary"
                  class="mt-2"
                />
              </v-list-item-content>
            </v-container>
          </v-list-item>
        </v-list>
      </v-container>
      <v-container
        v-else
        class="pa-0 ma-0 d-flex flex-column align-center justify-center"
        style="height: 337px"
      >
        <img
          :src="require('@/assets/dashboard/no-data(3).png')"
          max-width="100"
          height="100"
          contain
          class="mb-3"
        />
        <v-card-text class="text-body-2 grey--text text-center">
          {{ $t("nothing-for-render") }}
        </v-card-text>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "SalesByCustomer",
  props: {
    filterChart: {
      type: Object,
      default: null,
    },
    advanceFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      customers: [],
      loading: false,
    };
  },
  mounted() {
    this.getTopCustomerData();
  },
  computed: {
    hasData() {
      return this.customers.length > 0;
    },
    maxAmount() {
      if (this.customers.length > 0) {
        return Math.max(...this.customers.map((i) => i.amount));
      }
    },
  },
  watch: {
    filterChart: {
      deep: true,
      handler(newVal) {
        this.getTopCustomerData(newVal);
      },
    },
    advanceFilter: {
      deep: true,
      handler(newVal) {
        this.getTopCustomerData(newVal);
      },
    },
  },
  methods: {
    getPercent(value) {
      return Math.round((value / this.maxAmount) * 100);
    },
    formatPrice(value) {
      return value.toLocaleString("fa-IR");
    },
    getTopCustomerData(filters = {}) {
      const hasDefaultDate = !!filters?.fromDate && !!filters?.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/top-customers", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data.data.topCustomers.sell;
          app.customers = res.slice(-10);
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.scroll-y {
  overflow-y: auto;
  scrollbar-width: none;
}
.scroll-y::-webkit-scrollbar {
  display: none;
}
</style>
